// Opens a print window with QR + label + school name.
import { renderToStaticMarkup } from 'react-dom/server';
import { QRCodeSVG } from 'qrcode.react';

const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

const STYLE = 'body{font-family:system-ui,sans-serif;text-align:center;padding:40px}h1{font-size:40px;margin:16px 0 4px}h2{font-size:24px;color:#475569;font-weight:500;margin:0 0 24px}p{font-size:18px;color:#334155}small{display:block;margin-top:24px;color:#94a3b8;word-break:break-all}.sheet{page-break-after:always;break-after:page}.sheet:last-child{page-break-after:auto;break-after:auto}';

const sheetHtml = ({ url, label, schoolName, instruction, color }) => {
  const h1Color = /^#[0-9a-f]{6}$/i.test(color || '') ? `color:${color};` : '';
  const qr = renderToStaticMarkup(<QRCodeSVG value={url} size={320} level="M" />);
  return `<section class="sheet"><h2>${esc(schoolName)}</h2><h1${h1Color ? ` style="${h1Color}"` : ''}>${esc(label)}</h1>${qr}<p>${esc(instruction)}</p><small dir="ltr">${esc(url)}</small></section>`;
};

function openAndPrint(title, body, lang, dir) {
  const html = `<!doctype html><html lang="${esc(lang)}" dir="${esc(dir)}"><head><meta charset="utf-8"><title>${esc(title)}</title>
<style>${STYLE}</style></head><body>${body}</body></html>`;
  const w = window.open('', '_blank', 'width=800,height=1000');
  if (!w) return false;
  w.document.write(html); w.document.close();
  // Print from the opener: an inline <script> in the sheet would be blocked by the CSP.
  w.focus(); setTimeout(() => w.print(), 300);
  return true;
}

export function printSheet({
  url, label, schoolName, instruction, color,
  lang = document.documentElement.lang || 'en',
  dir = document.documentElement.dir || 'ltr',
}) {
  return openAndPrint(label, sheetHtml({ url, label, schoolName, instruction, color }), lang, dir);
}

// One window, one page per link.
export function printSheets(items, {
  lang = document.documentElement.lang || 'en',
  dir = document.documentElement.dir || 'ltr',
} = {}) {
  if (!items?.length) return false;
  return openAndPrint(items[0].schoolName || '', items.map(sheetHtml).join(''), lang, dir);
}
